import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import { Badge } from "primereact/badge";
import { InwardRawMaterialRequest } from "./Inward-RawMaterial-Request";
import { OutwardRawMaterialRequest } from "./Outward-RawMaterial-Request";

interface Props {
  visible: boolean;
  onHide: () => void;
  posId: number;
  onSendRequest: (request: any) => void;
  onRejectRequest: (request: any) => void;
  onSendinwardRequest: (request: any) => void;
  onRejectinwardRequest: (request: any) => void;
  setLoading: (loading: boolean) => void;
  outwardCount: number;
  inwardCount: number;
}

const IncomingRMRequestsDialog: React.FC<Props> = ({
  visible,
  onHide,
  posId,
  onSendRequest,
  onRejectRequest,
  onSendinwardRequest,
  onRejectinwardRequest,
  setLoading,
  outwardCount,
  inwardCount
}) => {
  return (
    <Dialog header="POS Requests" visible={visible} onHide={onHide} style={{ width: "70vw" }} modal>
      <TabView>
         <TabPanel
    header={
      <span style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
        Outward Requests{" "}
        {outwardCount > 0 && (
          <Badge value={outwardCount} severity="danger" className="ml-2" />
        )}
      </span>
    }
  >
          <OutwardRawMaterialRequest
            posId={posId}
            onSendRequest={onSendRequest}
            onRejectRequest={onRejectRequest}
            setLoading={setLoading}
          />
        </TabPanel>
        <TabPanel
    header={
      <span style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
        Inward Requests{" "}
        {inwardCount > 0 && (
          <Badge value={inwardCount} severity="info" className="ml-2" />
        )}
      </span>
    }
  >
          <InwardRawMaterialRequest
            posId={posId}
            onSendinwardRequest={onSendinwardRequest}
            onRejectinwardRequest={onRejectinwardRequest}
            setLoading={setLoading}
          />
        </TabPanel>
      </TabView>
    </Dialog>
  );
};

export default IncomingRMRequestsDialog;
